// components/models/MuseImageControlPanel.tsx
import React, { useCallback, memo } from 'react';
import AutoGrowingTextarea from '../AutoGrowingTextarea';
import { MuseImageParams } from '#types/types';
import { useKernel } from '@/kernel/Kernel';
import { useKernelStore } from '@/kernel/kernelStores';

export const getDefaultMuseImageParams = (): MuseImageParams => ({
  prompt: '',
  seed: -1,
});

const MuseImageControlPanel: React.FC = () => {
  const { kernel } = useKernel();
  const params = useKernelStore(
    state => state.modelParams[state.diffusionModel] as MuseImageParams | undefined
  );

  const handleParamChange = useCallback((
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const diffusionModel = kernel.current?.getDiffusionModel();
    if (!diffusionModel) return;

    kernel.current?.setModelParams(prevModelParams => {
      const currentParams = prevModelParams[diffusionModel];
      if (!currentParams) return prevModelParams;
      return { ...prevModelParams, [diffusionModel]: { ...currentParams, [name]: value } };
    });

    kernel.current?.logUserAction('Setting Changed', {
      setting_name: name,
      value_length: value.length,
      model_name: diffusionModel,
      source_component: 'MuseImageControlPanel',
    });
  }, [kernel]);

  if (!params) return null;

  return (
    <div>
      <AutoGrowingTextarea
        label="Prompt"
        placeholder="Describe what you want to change..."
        name="prompt"
        value={params.prompt}
        onChange={handleParamChange}
        onEnterPress={kernel.current?.triggerGenerate}
        maxHeight={600}
        labelClassName="block text-lg font-semibold text-white mb-2"
      />
    </div>
  );
};

export default memo(MuseImageControlPanel);
